const index = function (customerId) {
    return window.axios.get(`/api/customers/${customerId}/service-products`);
};

const create = function (customerId, data) {
    return window.axios.post(`/api/customers/${customerId}/service-products`, data);
};

const update = function (customerId, customerServiceProductId, data) {
    return window.axios.put(`/api/customers/${customerId}/service-products/${customerServiceProductId}`, data);
};

const destroy = function (customerId, customerServiceProductId) {
    return window.axios.delete(`/api/customers/${customerId}/service-products/${customerServiceProductId}`);
};

export default {
    index,
    create,
    update,
    destroy,
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/CustomerServiceProductService.js